import { connect } from "react-redux";
import './Topbar.styles.css';
import { GAME_NAME } from "../../../config/Game";
import { __Currency, __EventDispatcher, __Lang, __UrlParams } from "../../../../_core/core";
import { EventClass, EventType } from "../../../config/Events";
import Clock from "../clock/Clock";
import { useEffect, useState } from "react";

var pjson = require('../../../../../package.json');

const TopBar = (_props?: any) => {

	const [ canOpenSettings, setCanOpenSettings ] = useState<boolean>(true);

	useEffect(() => { 
    if(_props.drawStart) {   
			setCanOpenSettings(false);
    }  else {
			setCanOpenSettings(true);
		}
  }, [_props.drawStart]);

  if(__UrlParams.props.noTopBar === "true") return null;

	const openSettings = () => {
		__EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_SETTINGS);
	}
 
  return (
    <div className="top-bar">
      <span>{ GAME_NAME } &nbsp;
				<sup style={{ fontSize: '10px' }}>v.{ pjson.version }</sup>
			</span>
      <span >{ __Lang.translate('n:play.balance')}: { __Currency.format(_props.USER_DATA.credit)}</span>
			<span>
				<Clock />
				{ __UrlParams.props.siteID !== 30 ? (
					<button 
						className="settingsButton" 
						onClick={ () => openSettings() }
						disabled={!canOpenSettings}
						>
						<i className="fa fa-cog" aria-hidden="true"></i>	
					</button>
				): null }
			</span>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  return {
    USER_DATA: state.game.USER_DATA, 
		drawStart: state.game.GAMEPLAY.drawStart,
  };
}
 
export default connect(mapStateToProps, {})(TopBar);